const axios = require('axios')

// Configuración para subdominios en producción:
const API_URL = 'https://apievaluacion.ucat.edu.ve/api'

// Línea original comentada para cuando se activen los dominios:
//const API_URL = process.env.VUE_APP_API_URL

// Forzado temporal con la IP pública actual de pruebas:
//const API_URL = 'http://190.202.129.94:8080/api'

class AuthService {
  login(user) {
    return axios
      .post(API_URL + '/auth/login', {
        cedula: user.cedula,
        password: user.password
      })
      .then(response => {
        if (response.data.access_token) {
          sessionStorage.setItem('token', JSON.stringify(response.data));
        }

        return response.data;
      }).catch((e) => console.log(e));
  }

  verifyUser(token) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token
    axios.defaults.headers.common["Accept"] = "*/*"
    return axios
      .post(API_URL + '/auth/me')
      .then(response => {
        sessionStorage.setItem('user', JSON.stringify(response.data))

        return response.data;
      }).catch((e) => console.log(e));
  }

  logout() {
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('token');
  }
}

export default new AuthService();
